const LoginRoutes = {
  path: "/",
  children: [
    {
      path: "/login",
      element: <div>Products</div>,
    },
  ],
};

export default LoginRoutes;
